module.exports = __webpack_public_path__ + "img/744.aa1faccf.jpg";